import { ChainId } from '@traderjoe-xyz/joepegs-sdk'
import { CollectionType, ItemDetail } from 'types/nft'

/**
 * OpenSea item page in Sell mode, where "List for sale" is the main action.
 * OpenSea has no link that opens its listing modal. Null off Avalanche
 * mainnet: opensea.io shows mainnet items only.
 */
export const getOpenSeaListingUrl = (item: ItemDetail): string | null =>
  item.chainId === ChainId.AVALANCHE
    ? `https://opensea.io/item/avalanche/${item.collection}/${item.tokenId}?action=sell`
    : null

export const getIsOwner = (
  itemDetail?: ItemDetail | null,
  account?: string | null
): boolean =>
  account
    ? itemDetail?.owner?.ownerId.toLowerCase() === account.toLowerCase()
    : false

interface OnChainOwnership {
  account?: string
  balance?: bigint
  ownerOf?: string
}

/**
 * Replaces the indexed owner with on-chain data. ERC-721: `ownerOf` when
 * the call answered, else the indexed owner. ERC-1155: the connected
 * account with its balance, or no owner when it holds none.
 */
export const withOnChainOwner = (
  item: ItemDetail,
  { account, balance, ownerOf }: OnChainOwnership
): ItemDetail => {
  if (item.collectionType === CollectionType.ERC1155) {
    const quantity = balance === undefined ? 0 : Number(balance)
    return {
      ...item,
      owner:
        account && quantity > 0
          ? { ownerId: account.toLowerCase(), quantity }
          : null
    }
  }
  return ownerOf
    ? { ...item, owner: { ownerId: ownerOf.toLowerCase(), quantity: 1 } }
    : item
}
